export default __webpack_public_path__ + "static/media/sideMenu_doubt.64c27370.svg";